import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (data) {
    return store.dispatch('checkResponseApi', await Api().get('warehouses'))
  },

  async getSingle (params) {
    return store.dispatch('checkResponseApi', await Api().get('warehouse', { params }))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('warehouse', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('warehouse', data, options))
  },

  async updateAssignSkus (id, data) {
    let options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`warehouse/${id}/assign-skus`, data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('warehouse', { data: data }, options))
  },

  async insertBins (id, data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post(`warehouse/${id}/bin-locations`, data, options))
  },

  async updateBins (id, data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`warehouse/${id}/bin-locations`, data, options))
  },

  async deleteBins (id, data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`warehouse/${id}/bin-locations`, { data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/WarehouseService.js